export const DISMISS_ALMA = "dismiss_alma";
